import { createSlice } from '@reduxjs/toolkit';

export const investmentSlice = createSlice({
    name: 'investment',
    initialState: {
        dataToAction: { whoInvests: '', amount: '', participationValuation:'', vehicle:'' }
    },
    reducers: {
        selectInvestment: (state, {payload}) => {
            state.dataToAction = payload;
        },
        unSelectInvestment: (state) => {
            state.dataToAction = { whoInvests: '', amount: '', participationValuation:'', vehicle:'' }
        }
    }
});

export const { selectInvestment, unSelectInvestment } = investmentSlice.actions;